import { VisitaEstado, VisitStatus } from './visitasStatus';

export const transformVisitasResponse = (response: { data: any }) => ({
    data: {
        totalCount: response.data.totalCount,
        take: response.data.take,
        skip: response.data.skip,
        count: response.data.count,
        data: response.data.data.map((visita: any) => ({
            raw: visita,
            id: visita.id,
            nombreTipoVisita: visita?.tipoVisita?.descripcion,
            idTipoVisita: visita?.tipoVisita?.id,
            city: visita?.establecimiento?.direccion?.localidad
                ? visita?.establecimiento?.direccion?.localidad?.nombre
                : '-',
            zipCode: visita?.establecimiento?.direccion?.codigoPostal?.codigo || '-',
            fechaLimite: visita?.fechaLimite,
            fechaVisita: visita?.fechaVisita,
            estado: visita?.estado,
            nombreEstado: VisitStatus[visita?.estado as VisitaEstado] ?? '-',
            idPreventor: visita?.preventor?.idUsuario,
            nombrePreventor: visita?.preventor
                ? `${visita.preventor.nombre} ${visita.preventor.apellido ?? ''}`.trim()
                : '-',

            firmaPreventor: visita?.firmaPreventor,
            firmaResponsable: visita?.firmaResponsable,
            idEstablecimiento: visita?.establecimiento?.id,
            nroContrato: visita?.establecimiento?.organismo?.organismoCentral?.nombre,
            organismo: visita?.establecimiento?.organismo?.nombre,
            nombreEstablecimiento: visita?.establecimiento?.nombre,
            direccion: {
                calle: visita?.establecimiento?.direccion?.calle ?? '',
                altura: visita?.establecimiento?.direccion?.altura ?? '',
                departamento: visita?.establecimiento?.direccion?.departamento ?? null
            },
            actividades: visita?.actividades ?? [],
            establecimiento: {
                ...visita.establecimiento,
                organismoCentral: visita?.establecimiento?.organismo?.organismoCentral,
                organismo: visita?.establecimiento?.organismo
            },
            observacion: visita?.observacion,
            verosimilitudRespuestas: visita?.verosimilitudRespuestas,
            idVisita: visita?.visitaPresentacion?.idVisita,
            idPresentacion: visita?.visitaPresentacion?.idPresentacion || visita?.rgrl?.id,
            idTipoPresentacion: visita?.visitaPresentacion?.presentacion?.tipo?.id,
            rgrl: visita?.rgrl,
            tieneVerosimilitud: visita?.tieneVerosimilitud,
            tieneVisitaTecnica: visita?.tieneVisitaTecnica,
            tieneDocumentacionAdicional: visita?.tieneDocumentacionAdicional,
            actaVerosimilitudDisponiblePorDatos: visita?.actaVerosimilitudDisponiblePorDatos,
            totalPersonal: visita?.totalPersonal,
            personalProduccion: visita?.personalProduccion,
            administrativos: visita?.administrativos,
            profesional: visita?.profesional,
            matricula: visita?.matricula,
            fechaProgramada: visita?.fechaProgramada,
            preventor: visita?.preventor ?? null,
            siniestro: visita?.siniestro ?? null,
            motivoFalla: visita?.motivoFalla ?? null,
            // Fallas registradas: el resumen del establecimiento ofrece el acta de visita
            // fallida con el mismo criterio que la grilla (SMP-513).
            fallas: visita?.fallas,
            // Sin `?? null`: ausente (backend sin el dato) se muestra "-" y null es Pendiente (SMP-456)
            estadoArchivoSRT: visita?.estadoArchivoSRT
        }))
    }
});
